/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LinkApplePayTokenGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type LinkApplePayTokenRequest = {
  /**
   * ID of the Moov account representing the cardholder.
   */
  accountID: string;
  linkApplePay: components.LinkApplePay;
};

export type LinkApplePayTokenResponse = {
  headers: { [k: string]: Array<string> };
  result: components.LinkedApplePayPaymentMethod;
};

/** @internal */
export const LinkApplePayTokenGlobals$inboundSchema: z.ZodType<
  LinkApplePayTokenGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type LinkApplePayTokenGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const LinkApplePayTokenGlobals$outboundSchema: z.ZodType<
  LinkApplePayTokenGlobals$Outbound,
  z.ZodTypeDef,
  LinkApplePayTokenGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function linkApplePayTokenGlobalsToJSON(
  linkApplePayTokenGlobals: LinkApplePayTokenGlobals,
): string {
  return JSON.stringify(
    LinkApplePayTokenGlobals$outboundSchema.parse(linkApplePayTokenGlobals),
  );
}
export function linkApplePayTokenGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<LinkApplePayTokenGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LinkApplePayTokenGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinkApplePayTokenGlobals' from JSON`,
  );
}

/** @internal */
export const LinkApplePayTokenRequest$inboundSchema: z.ZodType<
  LinkApplePayTokenRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  LinkApplePay: components.LinkApplePay$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "LinkApplePay": "linkApplePay",
  });
});
/** @internal */
export type LinkApplePayTokenRequest$Outbound = {
  accountID: string;
  LinkApplePay: components.LinkApplePay$Outbound;
};

/** @internal */
export const LinkApplePayTokenRequest$outboundSchema: z.ZodType<
  LinkApplePayTokenRequest$Outbound,
  z.ZodTypeDef,
  LinkApplePayTokenRequest
> = z.object({
  accountID: z.string(),
  linkApplePay: components.LinkApplePay$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    linkApplePay: "LinkApplePay",
  });
});

export function linkApplePayTokenRequestToJSON(
  linkApplePayTokenRequest: LinkApplePayTokenRequest,
): string {
  return JSON.stringify(
    LinkApplePayTokenRequest$outboundSchema.parse(linkApplePayTokenRequest),
  );
}
export function linkApplePayTokenRequestFromJSON(
  jsonString: string,
): SafeParseResult<LinkApplePayTokenRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LinkApplePayTokenRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinkApplePayTokenRequest' from JSON`,
  );
}

/** @internal */
export const LinkApplePayTokenResponse$inboundSchema: z.ZodType<
  LinkApplePayTokenResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.LinkedApplePayPaymentMethod$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type LinkApplePayTokenResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.LinkedApplePayPaymentMethod$Outbound;
};

/** @internal */
export const LinkApplePayTokenResponse$outboundSchema: z.ZodType<
  LinkApplePayTokenResponse$Outbound,
  z.ZodTypeDef,
  LinkApplePayTokenResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.LinkedApplePayPaymentMethod$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function linkApplePayTokenResponseToJSON(
  linkApplePayTokenResponse: LinkApplePayTokenResponse,
): string {
  return JSON.stringify(
    LinkApplePayTokenResponse$outboundSchema.parse(linkApplePayTokenResponse),
  );
}
export function linkApplePayTokenResponseFromJSON(
  jsonString: string,
): SafeParseResult<LinkApplePayTokenResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LinkApplePayTokenResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinkApplePayTokenResponse' from JSON`,
  );
}
